import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(
  <path
    fillRule="evenodd"
    d="M8 16h8V8H8v8zm4-14C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"
  />,
  'StopCircle',
);
